import { Injectable } from '@angular/core';

@Injectable()
export abstract class DeleteFormStrategy {
  abstract readonly title: string;
  abstract readonly subtitle: string;
  abstract readonly deleteButtonLabel: string;
  abstract readonly cancelButtonLabel: string;
}
